var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"CuckooTools"}},[_c('div',{staticClass:"CuckooTools-BG",style:({ backgroundImage: 'url(' + _vm.yousa + ')' })}),_c('viewHeader'),_c('viewMain'),_c('viewFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }